export const SHOW_PROMOTION_MEAL_DETAILS = 'SHOW_PROMOTION_MEAL_DETAILS';
export const HIDE_PROMOTION_MEAL_DETAILS = 'HIDE_PROMOTION_MEAL_DETAILS';
export const SHOW_PROMOTION_CONFIRMATION_MODAL = 'SHOW_PROMOTION_CONFIRMATION_MODAL';
export const HIDE_PROMOTION_CONFIRMATION_MODAL = 'HIDE_PROMOTION_CONFIRMATION_MODAL';
export const ADD_MEAL = 'addMeal';
export const UNSKIP_AND_ADD_MEAL = 'unSkipAndAddMeal';

export const showPromotionMealConfirmation = (actionType, menuSlug, mealId) => ({
  type: SHOW_PROMOTION_CONFIRMATION_MODAL,
  actionType,
  menuSlug,
  mealId,
});

export const hidePromotionMealConfirmation = () => ({
  type: HIDE_PROMOTION_CONFIRMATION_MODAL,
});
